import React from 'react'
import { MrnLink, UnitLink } from '../app/Links'
import TempleLabel from './TempleLabel'
import DmcCopyToClipboardTooltip from '../../util/DmcCopyToClipboardTooltip'

const Editable = ({ text, type, isEdit, children }) => {
  let content = ''
  switch (type) {
    case 'mrnLink':
      content = <MrnLink mrn={text} />
      break
    case 'personLink':
      content = <DmcCopyToClipboardTooltip value={text} path={`/person/${text}/summary?forward=true`} newTab />
      break
    case 'Unit Number':
      content = <UnitLink unitnumber={text} />
      break
    case 'Temple':
      content = <TempleLabel temple={text} />
      break
    default:
      content = text
      break
  }
  return <span>{isEdit ? children : content}</span>
}

export default Editable
